export default __webpack_public_path__ + "static/media/top_interieur.5b62527f.svg";